import React from 'react';
import { setLiteral } from "../js/helpers.js";
import {
    Block, Button, Row, Col, Icon,
} from 'framework7-react';
import parse from 'html-react-parser';

export default class ContactInformation extends React.Component {

    state = {
        lsLiterales: '',
        configMiApp: ''
    }

    componentDidMount() {
        const { lsLiterales, configMiApp } = this.props;
        this.setState({ lsLiterales: lsLiterales, configMiApp: configMiApp });
    }

    render() {
        return (
            <Block>
                <Row className="aligner">
                    <Col width="100" medium="80" small="95">
                        <div id="features" className="divSection rowflex elevation-15" height={this.state.height} style={{ height: this.state.height }} >
                            <Row className={this.props.showTitle ? 'divTitle' : 'divTitle hide'} >
                                <Col width="100" className="">
                                    <Col width="85">
                                        <div>{setLiteral(this.state.lsLiterales, 102069)}</div>
                                    </Col>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="" width="100" medium="50" small="100" xsmall="100">
                                    <Row width="100">
                                        <Col width="100" className="textCenter">
                                            <h1>{setLiteral(this.state.lsLiterales, 101116)}</h1>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col width="100">
                                            <Row>
                                                <Col width="10" className="checkMarckContact">
                                                    <Icon f7="checkmark_alt_circle_fill"></Icon>
                                                </Col>
                                                <Col width="90">
                                                    <h3 >{setLiteral(this.state.lsLiterales, 101117)}</h3>
                                                    <p >{setLiteral(this.state.lsLiterales, 101118)}</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col width="100">
                                            <Row>
                                                <Col width="10" className="checkMarckContact">
                                                    <Icon f7="checkmark_alt_circle_fill"></Icon>
                                                </Col>
                                                <Col width="90">
                                                    <h3 >{setLiteral(this.state.lsLiterales, 101119)}</h3>
                                                    <p >{setLiteral(this.state.lsLiterales, 101120)}</p></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col width="100" className="" medium="50" small="100" xsmall="100">
                                    <Row >
                                        <Col width="100" className="textCenter" style={{ fontSize: "20px" }}>
                                            <h5>{setLiteral(this.state.lsLiterales, 101121)}</h5>
                                        </Col>
                                        <Col width="100" className="textCenter">
                                            <h3>
                                                {setLiteral(this.state.lsLiterales, 101122)}
                                            </h3>
                                            <h2 >
                                                {this.state.configMiApp.contact_phone}
                                            </h2>
                                        </Col>
                                        <Col width="100" className="textCenter" style={{ paddingBottom: "15px" }}>
                                            {this.state.configMiApp.miapp_contact_email}
                                        </Col>
                                    </Row>
                                    <Row style={{ paddingBottom: "30px" }}>
                                        <Col width="35"></Col>
                                        <Col width="10"><Button width="10" iconF7="logo_facebook" href="http://www.facebook.com/" external></Button></Col>
                                        <Col width="10"> <Button width="10" iconF7="logo_twitter" href="http://www.facebook.com/" external></Button></Col>
                                        <Col width="10"><Button width="10" iconF7="logo_linkedin" href="http://www.facebook.com/" external></Button></Col>
                                        <Col width="35"></Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Block>
        );
    };
}